import React, { useMemo } from 'react'

import CheckIcon from '../../assets/img/svg/complete-icon.svg'
import ConsumablesIcon from '../../assets/img/svg/dot-icon.svg'

const TasksConsumableList = ({ itemKey, dataList = [], noDataMessage = 'No Data yet.' }) => {
  const message = 'No Tasks yet.'

  const viewIcon = useMemo(() => (itemKey == 'consumables' ? ConsumablesIcon : CheckIcon), [itemKey])

  return dataList?.length > 0 ? (
    dataList?.filter((item)=>item?.is_completed)?.map((item, index) => (
      <div className="form-check form-switch mb-2 col-md-6" key={index}>
        <img src={viewIcon} alt={`image-${itemKey}`} />
        <label className="form-check-label">{item?.task || message}</label>
      </div>
    ))
  ) : (
    <div>
      <p className="fs-16 fw-400 black_color">{noDataMessage || message}</p>
    </div>
  )
}
export default TasksConsumableList
